import React, {useState} from 'react'
import {connect} from "react-redux";
import Spinner from 'react-bootstrap/Spinner'
import {Redirect} from "react-router";
import {loginAction} from '~/redux/actions/auth'
import './login.scss';
import {Link} from "react-router-dom";
import {setCurrentLanguage} from "~/redux/actions/translations";
import logoImg from "~/assets/logo-text-vertical.svg";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import LanguageSwitcher from '../../Components/LanguageSwitcher/LanguageSwitcher';

const Login = (props) => {

    const [code, setCode] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const langId = props.match.params.lang_id || 0;

    if (langId) {
        props.dispatch(setCurrentLanguage(langId));
    }

    const handleLoginUser = () => {

        setLoading(true);

        props.dispatch(loginAction(code)).then((response) => {
            setLoading(false);
            setMessage('');

            if (response.status !== 200) {
                setMessage(response.data?.message || 'Unknown error!');
            }
        });
    };

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            handleLoginUser();
        }
    };

    if (props.isAuthenticated) {
        if (props.user.role.is_guest) {
            return <Redirect to="/invitation"/>
        }
    }

    return (
        <div className="container container-login h-100 d-flex">
            <div className="row align-items-center">
                <div className="col-12">

                    <div className="card shadow p-sm-4 p-0 bg-white">
                        <div className="card-body text-center">
                            <div className="row">

                                <div className="col-12 mb-3">
                                    <img className="logo mb-3" src={logoImg}/>
                                    <h1 className="text-primary mb-0"><TextTranslate name="login-title" fallback="Login" textOnly/></h1>
                                </div>
                                <div className="col-12 mb-3">
                                    <p><TextTranslate name="login-desc" fallback="Welcome to the NEOM guest registration platform." textOnly/></p>
                                </div>
                                <div className="col-12">
                                    <form>
                                        <div className="form-group description">
                                            <label className="form-label w-100 text-left mb-0"><TextTranslate name="login-code-title" fallback="Unique Code" textOnly/></label>
                                            <small className="form-text text-left mt-0">
                                                <TextTranslate name="login-code-note" fallback="Please enter the unique code sent to you with your invitation." textOnly/>
                                            </small>
                                            <input onChange={e => setCode(e.target.value)}
                                                   onKeyDown={e => handleKeyPress(e)}
                                                   className="form-control"
                                                   type="password"/>
                                        </div>
                                        <div className="form-group mb-2">
                                            {message && (
                                                <div className="alert alert-danger" role="alert">
                                                    {message}
                                                </div>
                                            )}
                                            <button onClick={handleLoginUser} type="button" disabled={loading}
                                                    className="btn btn-primary w-100">
                                                {loading && <Spinner size="sm" animation="border"/>}
                                                <span><TextTranslate name="login-title" fallback="Login" textOnly/></span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-12">
                                    <Link className="link small" to="/reset-code">
                                        <TextTranslate name="login-new-code" fallback="Do you require a new code?" textOnly/>
                                    </Link>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <LanguageSwitcher className="no-header"/>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Login);
